let subscribers = {};

function subscribe(eventName, callback) {
	if (subscribers[eventName] === undefined) {
		subscribers[eventName] = [];
	}

	subscribers[eventName] = [...subscribers[eventName], callback];

	return function unsubscribe() {
		subscribers[eventName] = subscribers[eventName].filter((cb) => {
			return cb !== callback;
		});
	};
}

function publish(eventName, data) {
	if (subscribers[eventName]) {
		subscribers[eventName].forEach((callback) => {
			callback(data);
		});
	}
}

const PUB_SUB_EVENTS = {
	cartItemRemove: 'cart:item-remove',
	cartItemAdd: 'cart:item-add',
	cartItemQuantityUpdate: 'cart:item-quantity-update',
	cartError: 'cart:error',
	sliderSlideChange: 'slider:slide-change',
	collectionFilters: 'collection:filters',
	pageChange: 'page:change',
	searchOpen: 'search:open',
	searchClose: 'search:close',
	productModalOpen: 'product:modal-open',
	productModalClose: 'product:modal-close',
	mobileMenuOpen: 'mobile-menu:open',
	mobileMenuClose: 'mobile-menu:close',
	productVariantChange: 'product:variant-change',
	productQuantityUpdate: 'product:quantity-update',
	pickupAvailabilityDrawerOpen: 'pickup-availability-drawer:open',
	pickupAvailabilityDrawerClose: 'pickup-availability-drawer:close',
	searchResultsOpen: 'search-results:open',
	searchResultsClose: 'search-results:close',
	slideshowSlideChange: 'slideshow:slide-change',
	headerCartOpen: 'header-cart:open',
	headerCartClose: 'header-cart:close',
	headerSearchOpen: 'header-search:open',
	headerSearchClose: 'header-search:close',
};

document.addEventListener("DOMContentLoaded", function () {
  //Get the containers
  const productInfoContainer = document.getElementsByClassName('product-info-wrap-content')[0];
  const productInfoSidebar = document.getElementsByClassName('product-info-sidebar')[0];

  //Get the reviewDiv
  const reviewDiv = productInfoContainer.querySelector('.reputon-google-reviews-widget');

  //move the review to the sidebar
  productInfoSidebar.appendChild(reviewDiv.parentElement.parentElement);

  //change the container padding
  let containers = productInfoContainer.querySelectorAll('.container');
  containers.forEach(container => {
      container.style.padding = "4px";
      container.style.margin = "4px";
  });
  containers = productInfoContainer.querySelectorAll('.product-variants');
  containers.forEach(container => {
      container.style.padding = "4px";
      container.style.margin = "4px";
  });
  containers = productInfoContainer.querySelectorAll('.product-info-secondary');
  containers.forEach(container => {
      container.style.padding = "4px";
      container.style.margin = "4px";
  });
  containers = productInfoContainer.querySelectorAll('.product-info-main');
  containers.forEach(container => {
      container.style.padding = "8px";
      container.style.margin = "8px";
  });
  containers = productInfoContainer.querySelectorAll('#product-form-installment');
  containers.forEach(container => {
      container.style.padding = "4px";
      container.style.margin = "4px";
  });
});